import { Link, Outlet } from "react-router-dom";
import { IoMdAdd, IoIosSearch } from "react-icons/io";
import { IoCarSportOutline } from "react-icons/io5";
import { GrServices } from "react-icons/gr";
import { HiOutlineQrcode } from "react-icons/hi";
import { Userlogin } from "./general-function";

const ClientLayout = () => {
  return (
    <>
      <main className="client-content" style={{ minHeight: "100dvh" }}>
        <Outlet />
      </main>

      {Userlogin() && (
        <div
          style={{
            position: "sticky",
            bottom: "0",
            zIndex: "10",
            borderRadius: "17px 17px 0 0",

            boxShadow:
              "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
          }}
        >
          <div
            className="d-flex justify-content-between px-4 py-2"
            style={{
              borderRadius: "17px 17px 0 0",
              backgroundColor: "#ffefef",
            }}
          >
            <Link
              to={"/CarInquiry"}
              className="text-danger"
              style={{
                border: "none",
                backgroundColor: "transparent",
                fontSize: "14px",
                textAlign: "center",
              }}
            >
              <IoMdAdd style={{ fontSize: "20px" }} />
              <br /> Add
            </Link>
            <Link
              to={"/Catlogue/" + localStorage.getItem("Ca1itd")}
              className="text-danger"
              style={{
                border: "none",
                backgroundColor: "transparent",
                fontSize: "14px",
                textAlign: "center",
              }}
            >
              <IoCarSportOutline style={{ fontSize: "20px" }} />
              <br />
              Catalog
            </Link>
            <Link
              to="/CheckRC"
              className="text-danger"
              style={{
                border: "none",
                backgroundColor: "transparent",
                fontSize: "14px",
                textAlign: "center",
              }}
            >
              <IoIosSearch style={{ fontSize: "20px" }} /> <br />
              RC
            </Link>
            <Link
              to="/GenerateQr"
              className="text-danger"
              style={{
                border: "none",
                backgroundColor: "transparent",
                fontSize: "14px",
                textAlign: "center",
              }}
            >
              <HiOutlineQrcode style={{ fontSize: "20px" }} />
              <br />
              QR
            </Link>
            <Link
              to="/Service"
              className="text-danger"
              style={{
                border: "none",
                backgroundColor: "transparent",
                fontSize: "14px",
                textAlign: "center",
              }}
            >
              <GrServices />
              <br />
              Services
            </Link>
          </div>
        </div>
      )}
    </>
  );
};
export default ClientLayout;
